export default "__VITE_ASSET__PdGjL5$k__"